import { render } from "./EcoObstetrico.vue?vue&type=template&id=781fa462&scoped=true"
import script from "./EcoObstetrico.vue?vue&type=script&lang=js"
export * from "./EcoObstetrico.vue?vue&type=script&lang=js"

import "./EcoObstetrico.vue?vue&type=style&index=0&id=781fa462&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781fa462"]])

export default __exports__